import {v4 as uuid} from 'uuid'

export const getHeaders = ()=>{
    return (["ID","Type", "Originator", "Time","Severity"])
}

export const getList = ()=>{
    return([
        {
            id: uuid(),
            type: "Password change",
            originator: "Kevin Sampong",
            time: "12 March 2021, 12:30pm",
            severity: "moderate"
        }
    ])
}

// severity -> low, moderate, severe